import React from "react";

function CustomTable({data}) {
    return (
        <table className = "table">
          <thead>
            <tr>
              {Object.keys(data[0]).map((column) => (
                <th score = "col" key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                {Object.values(row).map((cell, index) => (
                  <td key={index}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      );

    };

export default CustomTable;

